import { Label, Typography } from '@equinor/eds-core-react';
import * as Styled from './ResultCaseMetadata.styled';

export const ResultCaseMetadata = ({
  computeMethod,
  modelArea,
  archel,
}: {
  computeMethod?: string;
  modelArea: string;
  archel?: string;
}) => {
  const displayType = archel
    ? archel.charAt(0).toUpperCase() + archel.slice(1)
    : computeMethod;

  return (
    <Styled.MetadataWrapperDiv>
      <Styled.MetadataDiv>
        <Label label="Object type"></Label>
        <Typography variant="h5"> {displayType}</Typography>
      </Styled.MetadataDiv>
      <Styled.MetadataDiv>
        <Label label="Area"></Label>
        <Typography variant="h5"> {modelArea}</Typography>
      </Styled.MetadataDiv>
    </Styled.MetadataWrapperDiv>
  );
};
